import { Text } from 'react-common'
import { useTranslation } from 'react-i18next'
import { Avatar } from '@platform/ui'
import { useAuth } from '@/features/auth/useAuth'
import styles from './ProfileHeader.module.scss'

export const ProfileHeader = () => {
  const { i18n } = useTranslation()
  const { user } = useAuth()

  const { first_name, middle_name, last_name } = user ?? {}
  const userName = [first_name, middle_name, last_name].filter(Boolean).join(' ')
  const isRTL = i18n.dir() === 'rtl'

  return (
    <div className={styles.profileHeaderContainer}>
      <Avatar name={userName} separator={isRTL ? ' ' : ''} />
      <Text.H1>{userName}</Text.H1>
    </div>
  )
}
